import type { CloudSnapshot, SyncRequest } from './userDataKeys';

export interface SyncJournal extends CloudSnapshot { initialized: boolean; inFlight?: SyncRequest; legacy?: Record<string, string | null> }
const DB = 'lianke-account-sync-v1';
const STORE = 'accounts';
let database: Promise<IDBDatabase> | undefined;
function openDatabase() {
  database ??= new Promise<IDBDatabase>((resolve, reject) => {
    const request = indexedDB.open(DB, 2);
    request.onupgradeneeded = () => {
      if (!request.result.objectStoreNames.contains(STORE)) request.result.createObjectStore(STORE);
      if (!request.result.objectStoreNames.contains('local-values')) request.result.createObjectStore('local-values');
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => { database = undefined; reject(new Error('无法打开本机同步缓存，请检查浏览器存储权限')); };
    request.onblocked = () => { database = undefined; reject(new Error('同步缓存被其他页面占用，请关闭旧页面后重试')); };
  });
  return database;
}
export async function loadLocalCache(userId: string): Promise<Record<string, string | null>> {
  const db = await openDatabase();
  return new Promise((resolve, reject) => {
    const request = db.transaction('local-values', 'readonly').objectStore('local-values').getAll(IDBKeyRange.bound([userId, ''], [userId, '\uffff']));
    request.onsuccess = () => resolve(Object.fromEntries(request.result.map(row => [row.key, row.value])));
    request.onerror = () => reject(new Error('无法读取本机记录缓存'));
  });
}
export async function cacheLocalValue(userId: string, key: string, value: string | null): Promise<void> {
  const db = await openDatabase();
  return new Promise((resolve, reject) => {
    const tx = db.transaction('local-values', 'readwrite');
    tx.objectStore('local-values').put({ key, value }, [userId, key]);
    tx.oncomplete = () => resolve();
    tx.onabort = tx.onerror = () => reject(new Error('本机缓存空间不足，请下载备份并释放浏览器空间后重试'));
  });
}
export async function loadJournal(userId: string): Promise<SyncJournal> {
  const db = await openDatabase();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, 'readonly');
    const request = tx.objectStore(STORE).get(userId);
    request.onsuccess = () => resolve(request.result || { initialized: false, revision: 0, items: {} });
    request.onerror = () => reject(new Error('无法读取本机同步缓存'));
  });
}
export async function saveJournal(userId: string, journal: SyncJournal): Promise<void> {
  const db = await openDatabase();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, 'readwrite');
    tx.objectStore(STORE).put(journal, userId);
    tx.oncomplete = () => resolve();
    tx.onabort = tx.onerror = () => reject(new Error('同步缓存空间不足，记录尚未上传，请导出备份后释放空间'));
  });
}
